import React, { useEffect, useState } from "react";
import "./Dashboard.css";
import { Card, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import Sidebar from "../../components/SidebarInvestigator/Sidebar";
import { GetInvestigatorDashboard } from "../../apis/DashboardAPI";
import {
  Chart,
  ChartLegend,
  ChartSeries,
  ChartSeriesItem,
  ChartSeriesItemTooltip,
  ChartTooltip,
} from "@progress/kendo-react-charts";
import "hammerjs";
import { GetNotifications } from "../../apis/NotificationAPI";
import dateFormat from "dateformat";
import { useSelector } from "react-redux";

export default function Dashboard() {
  const {user} = useSelector((state) => state.auth);
  const [assignedCount, setAssignedCount] = useState(0);
  const [inProgressCount, setInProgressCount] = useState(0);
  const [initialReviewCount, setInitialReviewCount] = useState(0);
  const [initialReviewedCount, setInitialReviewedCount] = useState(0);
  const [prelimReviewCount, setPrelimReviewCount] = useState(0);
  const [prelimReviewedCount, setPrelimReviewedCount] = useState(0);
  const [completedCount, setCompletedCount] = useState(0);
  const [notificationList, setNotificationList] = useState([]);

  async function GetUserNotifications() {
    var result = await GetNotifications();
    var data = result.data;
    setNotificationList(data.slice(0, 4));
  }

  useEffect(() => {
    async function GetOrderData() {
      var result = await GetInvestigatorDashboard(user.userid);
      var data = result.data;
      setAssignedCount(
        data.filter((d) => d.order_status_id === 8)[0].order_count
      );
      setInProgressCount(
        data.filter((d) => d.order_status_id === 6)[0].order_count
      );
      setInitialReviewCount(
        data.filter((d) => d.order_status_id === 9)[0].order_count
      );
      setInitialReviewedCount(
        data.filter((d) => d.order_status_id === 10)[0].order_count
      );
      setPrelimReviewCount(
        data.filter((d) => d.order_status_id === 11)[0].order_count
      );
      setPrelimReviewedCount(
        data.filter((d) => d.order_status_id === 12)[0].order_count
      );
      setCompletedCount(
        data.filter((d) => d.order_status_id === 3)[0].order_count
      );
    }
    GetOrderData();
    GetUserNotifications();
  }, []);

  window.addEventListener("notification", () => {
    GetUserNotifications();
  });

  const series = [
    { category: "Assigned", value: assignedCount },
    { category: "Orders in progress", value: inProgressCount },
    { category: "Reports in initial review", value: initialReviewCount },
    { category: "Initial reports reviewed", value: initialReviewedCount },
    { category: "Reports in prelim review", value: prelimReviewCount },
    { category: "Prelim report reviewed", value: prelimReviewedCount },
    { category: "Report completed", value: completedCount },
  ];

  return (
    <>
      <Container fluid>
        <Row>
          <div className="admin-wrapper">
            <div className="left-section">
              <Sidebar />
            </div>
            <div className="right-section">
              <Container fluid>
                <h1>Dashboard</h1>
                <Row>
                  <Col xl={4} lg={12} md={12} className="mb-5">
                    <div
                      cardinfo="data-Orders"
                      className="cards card investigator-dashboard-car"
                    >
                      <div className="cards-head">
                        <div className="cards-title h5">Orders</div>
                      </div>
                      <div className="cards-body">
                        <div className="cards-text">
                          <div className="cards-list-group">
                            <div className="cards-list-item">
                              <span className="text-blue">Assigned:</span> {assignedCount}
                            </div>
                            <div className="cards-list-item">
                              <span className="text-gray">In Progress:</span>{" "}
                              {inProgressCount}
                            </div>
                            <div className="cards-list-item">
                              <span className="text-blue">Initial Review:</span> {initialReviewCount}
                            </div>
                            <div className="cards-list-item">
                              <span className="text-gray">Initial Reviewed:</span>{" "}
                              {initialReviewedCount}
                            </div>
                            <div className="cards-list-item">
                              <span className="text-blue">Prelim Review:</span> {prelimReviewCount}
                            </div>
                            <div className="cards-list-item">
                              <span className="text-gray">Prelim Reviewed:</span>{" "}
                              {prelimReviewedCount}
                            </div>
                            <div className="cards-list-item">
                              <span className="text-sky">Completed:</span>{" "}
                              {completedCount}
                            </div>
                          </div>
                        </div>
                      </div>
                      <Link to="/Investigator/Orders" className="cards-link">
                        View All Orders
                      </Link>
                    </div>
                  </Col>
                  <Col xl={4} lg={12} md={12} className="mb-5">
                    <Card>
                      <Card.Body>
                        <Chart>
                          <ChartLegend position="bottom" />
                          <ChartTooltip visible={true} />
                          <ChartSeries>
                            <ChartSeriesItem
                              type="pie"
                              data={series}
                              field="value"
                              categoryField="category"
                            >
                              <ChartSeriesItemTooltip format="{0}" />
                            </ChartSeriesItem>
                          </ChartSeries>
                        </Chart>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
                <Row className="mt-5">
                  <Col xl={8} lg={12}>
                    <Card className="notifications-card">
                      <div className="card-head">
                        <div className="card-title h5">Notifications</div>
                      </div>
                      <ul className="notifications-list max-no-list">
                        {notificationList.map((item) =>
                          item.order_status_name === "Initial Reviewed" ? (
                            <li
                              className={item.view_id === 0 ? "unread" : ""}
                              key={item.id}
                            >
                              <p>
                                {item.order_user} has reviewed initial report of
                                Order number{" "}
                                <Link
                                  to={`/Investigator/OrderDetails?id=${item.order_id}`}
                                >
                                  {item.order_id}.
                                </Link>{" "}
                              </p>
                              <span className="text-italic">
                                {dateFormat(
                                  new Date(item.created_date + "Z"),
                                  "mmmm dd, yyyy hh:mmtt"
                                )}
                              </span>
                            </li>
                          ) : item.order_status_name === "Prelim Reviewed" ? (
                            <li
                              className={item.view_id === 0 ? "unread" : ""}
                              key={item.id}
                            >
                              <p>
                                {item.order_user} has reviewed prelim report of
                                Order number{" "}
                                <Link
                                  to={`/Investigator/OrderDetails?id=${item.order_id}`}
                                >
                                  {item.order_id}.
                                </Link>{" "}
                              </p>
                              <span className="text-italic">
                                {dateFormat(
                                  new Date(item.created_date + "Z"),
                                  "mmmm dd, yyyy hh:mmtt"
                                )}
                              </span>
                            </li>
                          ) : (
                            <li
                              className={item.view_id === 0 ? "unread" : ""}
                              key={item.order_id}
                            >
                              <p>
                                Order number{" "}
                                <Link
                                  to={`/Investigator/OrderDetails?id=${item.order_id}`}
                                >
                                  {item.order_id}
                                </Link>{" "}
                                was assigned by {item.order_user}.{" "}
                              </p>
                              <span className="text-italic">
                                {dateFormat(
                                  new Date(item.created_date + "Z"),
                                  "mmmm dd, yyyy hh:mmtt"
                                )}
                              </span>
                            </li>
                          )
                        )}
                      </ul>
                      <Card.Link href="/Investigator/Notifications">
                        View All
                      </Card.Link>
                    </Card>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
}
